export enum ModelReducers {
  events = 'events',
  photos = 'photos',
  deviceDetails = 'deviceDetails',
  chambers = 'chambers',
  notes = 'notes',
  siteInstallationInfo = 'siteInstallationInfo',
}
